import Highcharts from 'highcharts';

export const HIGHCHARTS_OPTIONS: Highcharts.Options = {
  colors: ['#EB2766'],
  lang: {
    thousandsSep: ',',
    numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'],
  },
  title: {
    text: undefined,
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    area: {
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 1,
          y2: 1,
        },
        stops: [[0, 'rgba(83, 41, 106, 0.2)'], [1, 'rgba(255, 255, 255, 0.01)']],
      },
      marker: {
        enabled: false,
      },
    },
    series: {
      animation: false,
      color: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 1,
          y2: 0,
        },
        stops: [[0, 'rgb(235, 39, 102)'], [1, '#582869']],
      },
    },
  },
  yAxis: {
    title: {
      text: undefined,
    },
    labels: {
      style: {
        fontFamily: "'ShopifySans', Helvetica, Arial, 'Lucida Grande', sans-serif",
      },
    },
  },
  xAxis: {
    title: {
      text: undefined,
    },
    minTickInterval: 24 * 3600 * 1000 * 30,
    labels: {
      style: {
        fontFamily: "'ShopifySans', Helvetica, Arial, 'Lucida Grande', sans-serif",
      },
    },
    type: 'datetime',
  },
  tooltip: {
    borderWidth: 0,
    backgroundColor: 'rgb(48, 60, 74)',
    style: {
      color: 'white',
    },
    dateTimeLabelFormats: {
      second: '%B %Y',
      minute: '%B %Y',
      hour: '%B %Y',
      day: '%B %Y',
    },
  },
};

export const REV_CHART_OPTIONS: any = {
  chart: {
    type: 'area',
    backgroundColor: null,
  },
  yAxis: {
    labels: {
      pointFormatter() {
        const {defaultLabelFormatter} = (this as any).axis;
        if ((this as any).value < 0) {
          (this as any).value *= -1;
          return `-$${defaultLabelFormatter()}`;
        }
        return `$${defaultLabelFormatter()}`;
      },
    },
  },
  tooltip: {
    pointFormatter() {
      const yValue = (this as any).y;
      if (yValue < 0) {
        return `<b>-$${Highcharts.numberFormat(yValue * -1, 2, '.', ',')}</b>`;
      }
      return `<b>$${Highcharts.numberFormat(yValue, 2, '.', ',')}</b>`;
    },
  },
};

export const TRAFFIC_CHART_OPTIONS: any = {
  chart: {
    type: 'area',
    backgroundColor: null,
  },
  tooltip: {
    pointFormatter() {
      return `<b>${Highcharts.numberFormat((this as any).y, 0, '.', ',')}</b>`;
    },
  },
};
